import { Card, Flex, Divider } from 'antd';
import type { UserTracker } from 'models/user';

import { TrackerRow } from './tracker-row/TrackerRow';

interface Props {
  userId: number;
  trackers: UserTracker[];
}

export const TrackersPermissions = ({ userId, trackers }: Props) => {
  return (
    <Card style={{ background: 'transparent' }}>
      <Flex vertical gap={10}>
        {trackers.map((el, i) => {
          return (
            <Flex vertical key={el.id}>
              <TrackerRow userId={userId} row={el} />
              {i !== trackers.length - 1 && <Divider style={{ margin: '12px 0' }} />}
            </Flex>
          );
        })}
      </Flex>
    </Card>
  );
};
